module.exports = __webpack_public_path__ + "img/d2.36c554c4.png";